'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');
var MobileSidebarMenu = require('./MobileSidebarMenu.js');
require('../NavbarMobile.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var MobileSidebar = function (props) {
    var onCloseClick = props.onCloseClick, logoPath = props.logoPath, navigationMenu = props.navigationMenu, childMenu = props.childMenu, grandChildMenu = props.grandChildMenu, NextLink = props.NextLink;
    return (React__default['default'].createElement("div", { className: "navigation__mobile--background" },
        React__default['default'].createElement("div", { className: "navigation__mobile" },
            React__default['default'].createElement("div", { className: "navigation__mobile--closeBtn" },
                React__default['default'].createElement("span", { className: "lifepal__icon lifepal__icon--close", onClick: onCloseClick })),
            React__default['default'].createElement(MobileSidebarMenu, { NextLink: NextLink, logoPath: logoPath, navigationMenu: navigationMenu, childMenu: childMenu, grandChildMenu: grandChildMenu }))));
};

module.exports = MobileSidebar;
//# sourceMappingURL=MobileSidebar.js.map
